import React, { useMemo } from "react";
import styled from "styled-components";
import { Formik, Form } from "formik";
import { Col, Row, RowContainer } from "components/lookup-tables/layout-componets";
import { FormSubmit } from "components/common";
import { useCreateAdapter, useUpdateAdapter } from "components/lookup-tables/hooks/useLookupTablesAPI";
import useScopePermissions from "hooks/useScopePermissions";
import usePluginEntities from "hooks/usePluginEntities";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import AdapterFormFields from "./AdapterFormFields";
const FlexForm = styled(Form)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`;
const Title = ({ title, typeName, create }) => {
  const TagName = create ? "h3" : "h2";
  return /* @__PURE__ */ React.createElement(TagName, { style: { marginBottom: "12px", width: "100%" } }, title, " ", /* @__PURE__ */ React.createElement("small", null, "(", typeName, ")"));
};
const INIT_ADAPTER = {
  id: void 0,
  title: "",
  description: "",
  name: "",
  custom_error_ttl_enabled: false,
  custom_error_ttl: null,
  custom_error_ttl_unit: null,
  config: {}
};
const DataAdapterForm = ({ type, title, saved, onCancel, create = false, dataAdapter = INIT_ADAPTER }) => {
  const sendTelemetry = useSendTelemetry("lut_data_adapter");
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(dataAdapter);
  const { createAdapter, creatingAdapter } = useCreateAdapter();
  const { updateAdapter, updatingAdapter } = useUpdateAdapter();
  const adapterPlugins = usePluginEntities("lookupTableAdapters");
  const plugin = adapterPlugins.find((p) => p.type === type);
  const DocComponent = plugin == null ? void 0 : plugin.documentationComponent;
  const pluginDisplayName = (plugin == null ? void 0 : plugin.displayName) || type;
  const initialValues = useMemo(() => {
    if ((plugin == null ? void 0 : plugin.prepareConfig) && (dataAdapter == null ? void 0 : dataAdapter.config)) {
      return { ...dataAdapter, config: plugin.prepareConfig(dataAdapter.config) };
    }
    return dataAdapter;
  }, [dataAdapter, plugin]);
  const handleSubmit = async (values) => {
    const promise = create ? createAdapter(values) : updateAdapter(values);
    return promise.then((response) => {
      var _a;
      sendTelemetry(TELEMETRY_EVENT_TYPE.LUT[create ? "DATA_ADAPTER_CREATED" : "DATA_ADAPTER_UPDATED"], {
        app_pathname: "lut",
        event_details: {
          type: (_a = dataAdapter == null ? void 0 : dataAdapter.config) == null ? void 0 : _a.type
        }
      });
      saved(response);
    });
  };
  const canModify = create || !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable);
  return /* @__PURE__ */ React.createElement(RowContainer, { style: { flexGrow: 1 }, $withDocs: !!DocComponent }, /* @__PURE__ */ React.createElement(Col, { style: { flexGrow: 1, height: "100%" } }, /* @__PURE__ */ React.createElement(Title, { title, typeName: pluginDisplayName, create }), /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: handleSubmit, validateOnBlur: false, enableReinitialize: true }, ({ isSubmitting, isValid }) => /* @__PURE__ */ React.createElement(FlexForm, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(Row, { $gap: "xl", style: { flexGrow: 1 } }, /* @__PURE__ */ React.createElement("div", { style: { width: DocComponent ? "60%" : "100%" } }, /* @__PURE__ */ React.createElement(AdapterFormFields, null)), DocComponent && /* @__PURE__ */ React.createElement("div", { style: { width: "40%", flexGrow: 0 } }, /* @__PURE__ */ React.createElement(DocComponent, { dataAdapterId: dataAdapter == null ? void 0 : dataAdapter.id }))), canModify && /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "flex-end" }, /* @__PURE__ */ React.createElement(
    FormSubmit,
    {
      submitButtonText: create ? "Create adapter" : "Update adapter",
      submitLoadingText: create ? "Creating adapter..." : "Updating adapter...",
      isSubmitting: isSubmitting || creatingAdapter || updatingAdapter,
      disabledSubmit: isSubmitting || creatingAdapter || updatingAdapter || !isValid,
      isAsyncSubmit: true,
      onCancel
    }
  ))))));
};
export default DataAdapterForm;
